/**
 * Class Menu Primary.
 */
export default class MenuFooterMobile {
  static openSubMenuClass: string = 'js-openSubMenu';

  constructor(selectorOpen: string) {
    const openSubMenus: NodeListOf<HTMLElement> =
      document.querySelectorAll(selectorOpen);

    MenuFooterMobile.openCloseSubMenu(openSubMenus);
  }

  /*
   * Open or Close  SubMenu Mobile
   * */
  private static openCloseSubMenu(openSubMenus: NodeListOf<HTMLElement>) {
    const arrayOpenSubMenus: Array<HTMLElement> = Array.from(openSubMenus);

    for (const openSubMenuElt of arrayOpenSubMenus) {
      openSubMenuElt
        .querySelector('.c-menuFooter__item--title')
        .addEventListener(
          'click',
          (event) => {
            event.stopPropagation();
            if (event.target instanceof HTMLElement) {
              const currentLinkAccordion: HTMLElement = event.target;
              const openItem: string = MenuFooterMobile.openSubMenuClass;

              // Close all other accordion
              arrayOpenSubMenus
                .filter(
                  (subMenu: HTMLElement) =>
                    currentLinkAccordion.parentElement !== subMenu
                )
                .map((subMenu: HTMLElement) =>
                  subMenu.classList.remove(openItem)
                );

              // Toggle current accordion's parent
              currentLinkAccordion.parentElement.classList.toggle(openItem);
            }
          },
          { passive: true }
        );
    }
  }
}
